import WatchPlusImage from "../assets/watchplus.png";

export default function Header() {
  return (
    <>
      <img
        src={WatchPlusImage}
        className="w-full h-24 mb-8 object-contain"
        alt="Watch+"
      />
      <div className="font-bold text-4xl">Insider NFTs</div>
    </>
  );
}
